import React from 'react'
import {FormFieldGroup, RadioInput, RadioInputGroup, TextInput, View} from '@instructure/ui'
import {deepEqual} from '@instructure/ui-utils'


const values = {
    'prod': {
        'authorizationUri': 'https://sso.canvaslms.com/api/lti/authorize_redirect',
        'tokenUri': 'https://sso.canvaslms.com/login/oauth2/token',
        'jwkSetUri': 'https://sso.canvaslms.com/api/lti/security/jwks'
    },
    'beta': {
        'authorizationUri': 'https://sso.beta.canvaslms.com/api/lti/authorize_redirect',
        'tokenUri': 'https://sso.beta.canvaslms.com/login/oauth2/token',
        'jwkSetUri': 'https://sso.beta.canvaslms.com/api/lti/security/jwks'
    },
    'test': {
        'authorizationUri': 'https://sso.test.canvaslms.com/api/lti/authorize_redirect',
        'tokenUri': 'https://sso.test.canvaslms.com/login/oauth2/token',
        'jwkSetUri': 'https://sso.test.canvaslms.com/api/lti/security/jwks'
    }
}

const labels = {
    'prod': 'Production',
    'beta': 'Beta',
    'test': 'Test'
}


const findEnv = function (expectedValue) {
    // We get more properties on the supplied value, so we just want to look at a few
    const filteredValue = (({authorizationUri, tokenUri, jwkSetUri}) => ({
        authorizationUri,
        tokenUri,
        jwkSetUri
    }))(expectedValue)
    for (const [env, value] of Object.entries(values)) {
        if (deepEqual(filteredValue, value)) {
            return env
        }
    }
    return 'custom'
}

const renderCustom = function (props) {
    return <View as='div' margin='medium'>
        <FormFieldGroup description='Custom Provider'>
            <TextInput renderLabel='Authorization URI'
                       type='url'
                       value={props.value.authorizationUri}
                       onChange={(_, authorizationUri) => props.onChange({
                           ...props.value,
                           authorizationUri
                       })}/>
            <TextInput renderLabel='Token URI'
                       type='url'
                       value={props.value.tokenUri}
                       onChange={(_, tokenUri) => props.onChange({
                           ...props.value,
                           tokenUri
                       })}/>
            <TextInput renderLabel='JWK Set URI'
                       type='url'
                       value={props.value.jwkSetUri}
                       onChange={(_, jwkSetUri) => props.onChange({
                           ...props.value,
                           jwkSetUri
                       })}/>
        </FormFieldGroup>
    </View>
}

const EditLtiProvider = function (props) {
    const [env, setEnv] = React.useState(findEnv(props.value))

    return <>
        <RadioInputGroup name='provider' label='Provider' value={env}
                         description='Provider Configuration'>
            {Object.entries(values).map(([env, value]) => {
                return <RadioInput key={env} label={labels[env]} value={env} onChange={() => {
                    setEnv(env);
                    props.onChange(value)
                }}
                />
            })}
            <RadioInput label='Custom' value='custom' onChange={() => setEnv('custom')}/>
        </RadioInputGroup>
        {env === 'custom' && renderCustom(props)}
    </>

}

export default EditLtiProvider
